import { render } from "./BaseTabs.vue?vue&type=template&id=8579b708&scoped=true"
import script from "./BaseTabs.vue?vue&type=script&lang=js"
export * from "./BaseTabs.vue?vue&type=script&lang=js"

import "./BaseTabs.vue?vue&type=style&index=0&id=8579b708&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8579b708"]])

export default __exports__